export default __webpack_public_path__ + "static/media/clock.09924b0e.svg";